<template>
  <transition name="modal">
    <div class="modal-mask" v-if="display">
      <div class="modal-wrapper" :style="`left: ${left}px; top: ${top}px`">
        <div class="close" @click="close"></div>
        <div class="modal-container">
          <div class="cancel" @click="close">Cancel</div>
          <div class="delete" @click="confirm">Delete</div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    display: {
      type: Boolean,
      required: true,
    },
    left: {
      type: Number,
      required: true,
    },
    top: {
      type: Number,
      required: true,
    }    
  },
  watch: {
    display(value) {
      document.documentElement.style.overflow = value ? 'hidden' : 'auto'
    }
  },
  methods: {
    close() {
      this.$emit("close")
    },
    confirm() {
      this.$emit("confirm")
    }
  }
}
</script>

<style lang="scss" scoped>
  .modal-mask {
    position: fixed;
    z-index: 100;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
  }

  .modal-wrapper {
    position: fixed;
  }

  .modal-container {
    width: 200px;
    margin: 0px auto;
    padding: 0px 0px;
    background-color: #F7F8F9;
    border-radius: 9px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
    font-family: Helvetica, Arial, sans-serif;
    transform: translate(-100%, 0%);
  }

  .modal-header h3 {
    margin-top: 0;
    color: #42b983;
  }

  .modal-body {
    margin: 20px 0;
  }

  .modal-default-button {
    float: right;
  }

  /*
  * The following styles are auto-applied to elements with
  * transition="modal" when their visibility is toggled
  * by Vue.js.
  *
  * You can easily play with the modal transition by editing
  * these styles.
  */

  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    transform: opacity 0.4s;
  }

  .delete, .cancel {
    text-align: center;
    width: 200px;
    padding: 20px 20px;
    font-family: var(--f-semi);
    font-size: 13px;
    cursor: pointer;
  }
  .cancel {
    color: #8E8E8E;
    border-bottom: 1px solid #E2E2E2;
  }
  .delete {
    color: #FF5050;
  }

  .close {
    opacity: 1;
    transform: translate(-100%, 0%);
    width: 44px;
    height: 44px;
    background-color: var(--white);
    background-image: url('../assets/images/icons/icon--cross.svg');
    background-repeat: no-repeat;
    background-position: center center;
    border-radius: 9px;
    margin-bottom: 8px;
    cursor: pointer;
    z-index: 999;
  }


</style>